import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { Icon } from "@iconify/react";
import CommentSkeleton from "./CommentSkeleton";
import "./CommentModal.css";
import ProfileBadge from "../../comman/ProfileBadge";

const CommentModal = ({
  show,
  onClose,
  highlightCommentId,  // for notification highlight

  comments,
  commentLoading,
  loadingMoreComments,  // NEW
  hasMoreComments,      // NEW
  onLoadMoreComments,   // NEW
  totalCommentsCount,   // NEW
  BASE_URL,
  currentUserId,
  postOwnerId,

  commentText,
  setCommentText,
  replyText,
  setReplyText,
  replyTo,
  setReplyTo,

  onAddComment,
  onAddReply,
  onLikeComment,
  onFetchReplies,
  onDelete,

  repliesMap,
  loadingReplies,
  activeMenuId,
  setActiveMenuId,

  showDeleteConfirm,
  setShowDeleteConfirm,
  deleteType,
  setDeleteTargetId,
  setDeleteType,
  setParentCommentId,

  onReport,
}) => {

  // ✅ ALL HOOKS BEFORE EARLY RETURN
  const commentRefs = useRef({});

  // Activity highlight — fades after 3s when modal opens
  // const [showHighlight, setShowHighlight] = useState(false);

  // useEffect(() => {
  //   if (!show) return;
  //   setShowHighlight(true);
  //   const timer = setTimeout(() => setShowHighlight(false), 3000);
  //   return () => clearTimeout(timer);
  // }, [show]);

  // Notification highlight — scroll to specific comment
  useEffect(() => {
    if (!show || !highlightCommentId || !comments.length) return;

    console.log("highlightCommentId inside modal:", highlightCommentId); // 👈 ADD
    console.log("comments inside modal:", comments.map(c => c._id));    // 👈 ADD
    console.log("commentRefs:", commentRefs.current);                    // 👈 ADD

    const timer = setTimeout(() => {
      const el = commentRefs.current[highlightCommentId];
      console.log("found element:", el); // 👈 ADD
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [show, highlightCommentId, comments]);

  // ✅ EARLY RETURN AFTER ALL HOOKS
  if (!show) return null;

  const canDelete = (ownerId) =>
    ownerId === currentUserId || postOwnerId === currentUserId;
  const canReport = (ownerId) => ownerId !== currentUserId;

  return (
    <>
      {/* COMMENT MODAL */}
      <div className="comment-modal">
        <div className="comment-box">
          <button
            onClick={() => {
              onClose();
              setReplyTo(null);
            }}
          >
            ✕
          </button>

          <h5>Comments {totalCommentsCount > 0 && `(${totalCommentsCount})`}</h5>

          {/* COMMENTS LIST */}
          <div className="comments-list">
            {commentLoading ? (
              <CommentSkeleton />
            ) : comments.length === 0 ? (
              <p className="no-comments text-center">No comments yet</p>
            ) : (
              comments.map((comment) => (
                <div
                  key={comment._id}
                  id={`comment-${comment._id}`} 
                  ref={(el) => { if (el) commentRefs.current[comment._id] = el; }}
                  className="comment"
                >
                  <div className="comment-profile-img-box">
                    <div className="post-header-link">
                      <ProfileBadge
                        ProfileLink={
                          comment?.user?._id === currentUserId
                            ? `/my/${currentUserId}/profile`
                            : `/user/${comment?.user?._id}/profile`
                        }
                        isBatch={comment?.user?.isBatch}
                        profilePic={comment.user.profilePic}
                      />
                    </div>
                  </div>

                  <div
                    // id={`comment-${comment._id}`}
                    className="comment-content"
                  >
                    <div className="d-flex">
                      <div className="bubble comment-bubble">
                        <div className="comment-header">
                          <p className="comment-user-name m-0">
                            {comment.user.fullName}
                          </p>
                        </div>
                        <p className="m-0">{comment.comment}</p>
                      </div>

                      <span
                        className="comment-menu-icon"
                        onClick={() =>
                          setActiveMenuId(
                            activeMenuId === comment._id ? null : comment._id,
                          )
                        }
                      >
                        ⋯
                        {activeMenuId === comment._id && (
                          <div className="comment-menu">
                            {canDelete(comment.user._id) && (
                              <div
                                className="danger"
                                onClick={() => {
                                  setDeleteTargetId(comment._id);
                                  setDeleteType("comment");
                                  setShowDeleteConfirm(true);
                                  setActiveMenuId(null);
                                }}
                              >
                                Delete
                              </div>
                            )}
                            {canReport(comment.user._id) && (
                              <div
                                className="comment-report"
                                onClick={() => {
                                  onReport({ id: comment._id, type: "comment" });
                                  setActiveMenuId(null);
                                }}
                              >
                                Report
                              </div>
                            )}
                          </div>
                        )}
                      </span>
                    </div>

                    {/* ACTIONS */}
                    <div className="comment-actions">
                      <span>
                        <FontAwesomeIcon
                          icon={comment.isLiked ? faHeart : faHeartRegular}
                          className={comment.isLiked ? "text-danger" : ""}
                          onClick={() => onLikeComment(comment._id)}
                        />
                        {comment.likesCount}
                      </span>

                      <span onClick={() => setReplyTo(comment._id)}>Reply</span>

                      {comment.repliesCount > 0 && (
                        <span onClick={() => onFetchReplies(comment._id)}>
                          {repliesMap[comment._id]
                            ? "Hide replies"
                            : `View replies (${comment.repliesCount})`}
                        </span>
                      )}

                      {loadingReplies[comment._id] && (
                        <div className="spinner-border spinner-border-sm" />
                      )}
                    </div>

                    {/* REPLIES */}
                    {repliesMap[comment._id]?.map((reply) => (
                      <div key={reply._id} className="reply">
                        <Link
                          to={
                            reply.user?._id === currentUserId
                              ? `/my/${currentUserId}/profile`
                              : `/user/${reply.user?._id}/profile`
                          }
                          className="post-header-link"
                        >
                          <ProfileBadge
                            ProfileLink={
                              reply.user?._id === currentUserId
                                ? `/my/${currentUserId}/profile`
                                : `/user/${reply.user?._id}/profile`
                            }
                            isBatch={reply?.user?.isBatch}
                            profilePic={reply.user.profilePic}
                            imgClassName={"profile_badge_reply_container"}
                            badgeClassName={"profile_badge_reply_img_section"}
                          />
                        </Link>

                        <div className="bubble reply-bubble">
                          <div className="comment-header">
                            <p className="comment-user-name m-0">
                              {reply.user?.fullName || "User"}
                            </p>
                          </div>
                          <p className="m-0">{reply.comment}</p>
                        </div>

                        <span
                          className="comment-menu-icon"
                          onClick={() =>
                            setActiveMenuId(
                              activeMenuId === reply._id ? null : reply._id,
                            )
                          }
                        >
                          ⋯
                          {activeMenuId === reply._id && (
                            <div className="comment-menu">
                              {canDelete(reply.user?._id) && (
                                <div
                                  className="danger"
                                  onClick={() => {
                                    setDeleteTargetId(reply._id);
                                    setDeleteType("reply");
                                    setParentCommentId(comment._id);
                                    setShowDeleteConfirm(true);
                                    setActiveMenuId(null);
                                  }}
                                >
                                  Delete
                                </div>
                              )}
                              {canReport(reply.user?._id) && (
                                <div
                                  className="comment-report"
                                  onClick={() => {
                                    onReport({ id: reply._id, type: "reply" });
                                    setActiveMenuId(null);
                                  }}
                                >
                                  Report
                                </div>
                              )}
                            </div>
                          )}
                        </span>
                      </div>
                    ))}

                    {/* REPLY INPUT */}
                    {replyTo === comment._id && (
                      <div className="reply-input">
                        <input
                          placeholder="Write a reply..."
                          value={replyText}
                          onChange={(e) => setReplyText(e.target.value)}
                          onKeyDown={(e) =>
                            e.key === "Enter" && onAddReply(comment._id)
                          }
                        />
                        <Icon
                          icon="ic:sharp-send"
                          onClick={() => onAddReply(comment._id)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>

          {/* LOAD MORE BUTTON */}
{!commentLoading && hasMoreComments && (
  <div className="load-more-comments">
    {loadingMoreComments ? (
      <div className="text-center my-2">
        <div className="spinner-border spinner-border-sm text-secondary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    ) : (
      <button 
        className="load-more-btn"
        onClick={onLoadMoreComments}
        disabled={loadingMoreComments}
      >
        Load more comments ({comments.length} of {totalCommentsCount})
      </button>
    )}
  </div>
)}

{/* Show total count when all loaded */}
{!commentLoading && !hasMoreComments && comments.length > 0 && (
  <p className="text-muted text-center small mt-2">
    Showing all {totalCommentsCount || comments.length} comments
  </p>
)}

          {/* Show total count when all loaded */}
          {!commentLoading && !hasMoreComments && comments.length > 0 && (
            <p className="text-muted text-center small mt-2">
              Showing all {totalCommentsCount} comments
            </p>
          )}

          {/* COMMENT INPUT */}
          <div className="comment-input">
            <input
              placeholder="Write a comment..."
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && onAddComment()}
            />
            <Icon icon="ic:sharp-send" onClick={onAddComment} />
          </div>
        </div>
      </div>

      {/* DELETE CONFIRM */}
      {showDeleteConfirm && (
        <div
          className="confirm-modal"
          onClick={() => setShowDeleteConfirm(false)}
        >
          <div className="confirm-box" onClick={(e) => e.stopPropagation()}>
            <h5>Delete {deleteType === "reply" ? "reply" : "comment"}?</h5>
            <p>This action cannot be undone.</p>
            <div className="confirm-actions">
              <button onClick={() => setShowDeleteConfirm(false)}>No</button>
              <button className="danger" onClick={onDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CommentModal;